import * as tslib_1 from "tslib";
import * as React from 'react';
import styled, { css } from '../styles';
export var cssStyle = function (props) {
    var center = props.center, start = props.start, around = props.around, between = props.between, end = props.end, top = props.top, middle = props.middle, bottom = props.bottom, stretch = props.stretch;
    var justify = 'flex-start';
    var alignItems;
    if (center) {
        justify = 'center';
    }
    else if (start) {
        justify = 'flex-start';
    }
    else if (around) {
        justify = 'space-around';
    }
    else if (between) {
        justify = 'space-between';
    }
    else if (end) {
        justify = 'flex-end';
    }
    if (top) {
        alignItems = 'flex-start';
    }
    else if (middle) {
        alignItems = 'center';
    }
    else if (bottom) {
        alignItems = 'flex-end';
    }
    else if (stretch) {
        alignItems = 'stretch';
    }
    var style = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    justify-content: ", ";\n    align-items: ", ";\n  "], ["\n    justify-content: ", ";\n    align-items: ", ";\n  "])), justify, alignItems);
    return style;
};
var RowWrapper = styled.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-flow: row wrap;\n  ", ";\n"], ["\n  display: flex;\n  width: 100%;\n  flex-flow: row wrap;\n  ", ";\n"])), cssStyle);
/**
 * Grid布局中的行组件
 *
 * @ReactComponent
 */
export default function Row(props) {
    var getGutterChildren = function (child, index) {
        var gutter = props.gutter, gutterType = props.gutterType, children = props.children;
        var childNumber = React.Children.count(children);
        var edgeGutter = gutterType === 'around' ? gutter / 2 : 0;
        var childProps = {
            style: tslib_1.__assign({ paddingLeft: index === 0 ? edgeGutter : gutter / 2, paddingRight: index === childNumber - 1 ? edgeGutter : gutter / 2 }, child.props.style),
        };
        return React.cloneElement(child, childProps);
    };
    var renderChildren = function () {
        var gutter = props.gutter;
        if (gutter > 0) {
            return React.Children.map(props.children, getGutterChildren);
        }
        else {
            return props.children;
        }
    };
    return React.createElement(RowWrapper, tslib_1.__assign({}, props), renderChildren());
}
export { RowWrapper };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Row.js.map